import { render, staticRenderFns } from "./portfolioCS.vue?vue&type=template&id=38cdf019"
import script from "./portfolioCS.vue?vue&type=script&lang=js"
export * from "./portfolioCS.vue?vue&type=script&lang=js"
import style0 from "./portfolioCS.vue?vue&type=style&index=0&id=38cdf019&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports